import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { ViewportScroller } from '@angular/common';

@Component({
    selector: 'app-how-we-work',
    templateUrl: './how-we-work.component.html',
    styleUrls: ['./how-we-work.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class HowWeWorkComponent implements OnInit {

  constructor(private viewportScroller: ViewportScroller) {}

  public onClick(elementId: string): void { 
      this.viewportScroller.scrollToAnchor(elementId);
  }

  ngOnInit() {
  }

}
